import { handleActions } from 'redux-actions-helpers';
import { add, del, edit } from './actions';

export const initialState = {
    items: []
};

export default handleActions({
    [add]: (state, action) => {
        return {
            items: [...state.items, action]
        }
    },
    [del]: (state, { index }) => {
        const items = [...state.items];

        items.splice(index, 1);

        return {
            ...state,
            items
        }
    },
    [edit]: (state, action) => {
        const items = [...state.items];

        for(let i = 0; i < items.length; i++) {
            if(items[i].localId === action.localId) {
                items[i] = action;
                break;
            }
        }

        return {
            items: items
        }
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/tasks/reducer.js